import React from 'react'
import PropTypes from 'prop-types'
import {defineMessages, useIntl} from 'react-intl'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
    IconButton,
    Icon,
    Box,
    Image
} from '@chakra-ui/react'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import {CustomClose} from '../icons'
import {getEuLegalGuaranteeNoticeAssetPath} from '@app/utils/eu-legal-guarantee'

const NOTICE_MAX_HEIGHT = 'calc(90vh - 5rem)'

const messages = defineMessages({
    title: {
        id: 'footer.euLegalGuaranteeNotice.modalTitle',
        defaultMessage: 'EU Legal Guarantee Notice'
    },
    close: {
        id: 'footer.euLegalGuaranteeNotice.close',
        defaultMessage: 'Close'
    },
    imageAlt: {
        id: 'footer.euLegalGuaranteeNotice.imageAlt',
        defaultMessage: 'EU harmonised legal guarantee of conformity notice'
    }
})

const EuLegalGuaranteeModal = ({isOpen, onClose, localeId}) => {
    const intl = useIntl()
    const assetPath = getEuLegalGuaranteeNoticeAssetPath(localeId)

    if (!assetPath) {
        return null
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered scrollBehavior="inside">
            <ModalOverlay bg="blackAlpha.600" />
            <ModalContent
                borderRadius={0}
                position="relative"
                w={{base: '92vw', md: '720px'}}
                maxW="720px"
                maxH="90vh"
                m={4}
                p={{base: 4, md: 6}}
                pt={{base: 10, md: 10}}
                pb={{base: 5, md: 6}}
                overflow="hidden"
                boxShadow="xl"
            >
                <IconButton
                    onClick={onClose}
                    icon={<Icon as={CustomClose} />}
                    aria-label={intl.formatMessage(messages.close)}
                    variant="ghost"
                    size="sm"
                    position="absolute"
                    top={3}
                    right={3}
                    zIndex={1}
                    background="transparent"
                    _hover={{background: 'transparent'}}
                />
                <ModalBody p={0} overflowY="auto" overflowX="hidden">
                    <Box
                        as="figure"
                        w="100%"
                        m={0}
                        aria-label={intl.formatMessage(messages.title)}
                    >
                        <Image
                            src={getAssetUrl(assetPath)}
                            alt={intl.formatMessage(messages.imageAlt)}
                            display="block"
                            mx="auto"
                            w="100%"
                            h="auto"
                            maxH={NOTICE_MAX_HEIGHT}
                            objectFit="contain"
                            loading="eager"
                        />
                    </Box>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

EuLegalGuaranteeModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    localeId: PropTypes.string
}

export default EuLegalGuaranteeModal
